module.exports = __webpack_public_path__ + "static/media/travel-hospitality.a09c68ed.png";